// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  font-family: roboto;
}
body{
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  /* min-height: 100vh; */
}
.app-container {
  display: flex;
  flex-direction: column;
  flex: 1 1; /* Allow the flex container to take up all available space */
}
.flex-container {
  flex: 1 1; 
}
/* .App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
} */

/* Disable text selection and copying globally */
* {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

body {
  -webkit-touch-callout: none; /* Disable long-press menu on mobile */
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO,EAAE,4DAA4D;AACvE;AACA;EACE,SAAO;AACT;AACA;;;;GAIG;;AAEH,gDAAgD;AAChD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B,EAAE,sCAAsC;AACrE","sourcesContent":["*{\r\n  font-family: roboto;\r\n}\r\nbody{\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* min-height: 100vh; */\r\n}\r\n.app-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1; /* Allow the flex container to take up all available space */\r\n}\r\n.flex-container {\r\n  flex: 1; \r\n}\r\n/* .App {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n} */\r\n\r\n/* Disable text selection and copying globally */\r\n* {\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\nbody {\r\n  -webkit-touch-callout: none; /* Disable long-press menu on mobile */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
